// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2Kyqz","errorLogs":"styles_errorLogs__q1stO"};